import React from "react";
import { Link } from "react-router-dom";
import useSaveFavouriteJob from "../../../../hooks/useSaveFavouriteJob";
import useFetchSavedFavouriteJob from "../../../../hooks/useFetchSavedFavouriteJob";
import {
  contractIcon,
  timerIcon,
  shopIcon,
  locationIcon,
  starIcon,
  usersIcon,
} from "../../../../utils/icons";
import "./jobPostCard.css";
import { useAuth } from "../../../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { deleteJob } from "../../../../api/job.service";
import useSignedImage from "../../../../hooks/useSignedImage";

const PostCard = ({ data, type, onEdit, onDelete }) => {
  const { jobPost: nestedJobPost, ...rest } = data;
  const jobPost = nestedJobPost || rest;
  const {
    id,
    position,
    location,
    schedule,
    restaurant,
    contract,
    yearsOfExperience = "N/A",
    vacancies,
    description,
    format = restaurant?.format || "",
    name = restaurant?.name || "N/A",
    createdAt,
    deactivatedAt,
  } = jobPost;


  const { saveFavouriteJob, loading, error, success, isSaved } =
    useSaveFavouriteJob(id);
  const { isAuthenticated, userInfo, logout } = useAuth();
  const navigate = useNavigate();
  const profileImage = data.restaurant?.profileImageUrl;
  
  // Use the signed image hook to handle Wasabi URLs
  const { imageUrl: signedImageUrl, isLoading: imageLoading, error: imageError } = useSignedImage(profileImage, '/default-restaurant.png');
  const maxLocationLength = 60;
  const truncatedLocation =
    location && location.address
      ? location.address.length > maxLocationLength
        ? `${location.address.slice(0, maxLocationLength)}...`
        : location.address
      : "No especificado";

  const handleEdit = () => {
    onEdit(jobPost);
  };

  const handleSave = () => {
    if (!isAuthenticated) {
      navigate("/profesionales/entrar");
      return;
    }
    saveFavouriteJob();
  };

  const handleApplyClick = () => {
    navigate(`/trabajos/${id}/aplicar`);
  };
  // comment
  const handleDetailsClick = () => {
    navigate(`/trabajos/${id}`, { state: { scrollToOffers: true } });
  };

  const handleDelete = async () => {
    try {
      await deleteJob(id);
      const message = "Trabajo eliminado";
      onDelete(message);
    } catch (error) {
      console.error("Error deleting job:", error);
    }
  };

  return (
    <div className="post-card__container">
      <div className="post-card__col-1">
        <img
          className="post-card__company-logo"
          src={signedImageUrl}
          alt={name}
        />
        <div className="post-card__info">
          <div className="post-card__info-main">
            <p>
              <strong>{position}</strong>
            </p>
            <p id="post-card__company-name">
              <strong>{name}</strong>
            </p>
          </div>
          <div className="post-card__info-footer-container">
            <div className="post-card__icon-title-container">
              {shopIcon}
              <div className="post-card__label-info-container">
                <p>
                  <strong>Establecimiento:</strong>
                </p>
                <p>{format}</p>
              </div>
            </div>
            <div className="post-card__icon-title-container">
              {locationIcon}
              <div className="post-card__label-info-container">
                <p>
                  <strong>Ubicación:</strong>
                </p>
                <p>{truncatedLocation}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="post-card__col-2">
        <div className="post-card__icons-posts_container">
          <div className="post-card__icon-title-container">
            {timerIcon}
            <div className="post-card__label-info-container">
              <strong>
                <p>Jornada:</p>
              </strong>
              <p>{schedule}</p>
            </div>
          </div>
          <div className="post-card__icon-title-container">
            {starIcon}
            <div className="post-card__label-info-container">
              <strong>
                <p>Experiencia:</p>
              </strong>
              <p>
                {yearsOfExperience} {yearsOfExperience === 1 ? "año" : "años"}
              </p>
            </div>
          </div>
          <div className="post-card__icon-title-container">
            {contractIcon}
            <div className="post-card__label-info-container">
              <strong>
                <p>Contrato:</p>
              </strong>
              <p>{contract}</p>
            </div>
          </div>
          <div className="post-card__icon-title-container">
            {usersIcon}
            <div className="post-card__label-info-container">
              <strong>
                <p>Vacantes:</p>
              </strong>
              <p>{vacancies}</p>
            </div>
          </div>
        </div>
        <div>
          <div className="post-card__description-buttons-container">
            <div className="post-card__description-container">
              <div className="post-card__description"><h5>{description}</h5></div>
              <h5>Publicado el {new Date(createdAt).toLocaleDateString()}</h5>
            </div>
            <div
              className={
                type === "dashboard-company" || type === "dashboard-employee"
                  ? "post-card__double-button-container"
                  : "post-card__button-container"
              }>
              {type === "dashboard-company" ? (
                <>
                  <Link to={`/panel-empresa/trabajos/${id}/postulantes`}>
                    <button className="post-card__button-double">
                      Postulantes
                    </button>
                  </Link>
                  <Link to={`/panel-empresa/trabajos/${id}`}>
                    <button className="post-card__button-double">Editar</button>
                  </Link>
                  <button
                    onClick={handleDelete}
                    className="post-card__button-double">
                    Borrar
                  </button>
                </>
              ) : type === "dashboard-employee" ? (
                <>
                  <Link to={`/panel-empleado/postulaciones/trabajos/${id}`}>
                    <button className="post-card__button-double">
                      Detalle
                    </button>
                  </Link>
                  <Link to={`/panel-empleado/postulaciones/${data.id}`}>
                    <button className="post-card__button-double">
                      Postulación
                    </button>
                  </Link>
                </>
              ) : (
                <>
                  <button
                    onClick={handleApplyClick}
                    className="post-card__button">
                    Postular
                  </button>
                  <button
                    onClick={handleDetailsClick}
                    className="post-card__button">
                    Detalle
                  </button>
                  <button
                    onClick={handleSave}
                    className="post-card__button"
                    disabled={isSaved}>
                    {isSaved ? "Guardado" : "Guardar"}
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PostCard;
